export default "__VITE_ASSET__62faaef2__"